import { useState } from "react";
import { ChevronDown, ExternalLink } from "./Icons";
import { useData } from "../data/DataContext";

export function TriagePanel() {
  const data = useData();
  const [collapsed, setCollapsed] = useState(false);
  const [vals, setVals] = useState<Record<string, string>>({});

  const inputs = data.triage?.inputs ?? [];
  const templates = data.triage?.templates ?? {};

  const filled = Object.entries(vals).filter(([, v]) => v && v.length > 0);

  return (
    <section className="triage" id="triage">
      <header className="triage-head">
        <div>
          <h2 className="triage-title">Triage</h2>
          <p className="triage-sub">Paste a userId / traceId / contractId — get one-click deeplinks across every tool.</p>
        </div>
        <button className="ghost-btn" type="button"
                title={collapsed ? "Expand" : "Collapse"}
                onClick={() => setCollapsed((c) => !c)}
                style={{ transform: collapsed ? "rotate(180deg)" : undefined }}>
          <ChevronDown size={14} />
        </button>
      </header>
      {!collapsed && (
        <div>
          <div className="triage-row">
            {inputs.map((spec) => (
              <div key={spec.id} className="triage-input">
                <label htmlFor={`triage-${spec.id}`}>{spec.label}</label>
                <input id={`triage-${spec.id}`}
                       placeholder={spec.placeholder}
                       spellCheck={false}
                       autoComplete="off"
                       value={vals[spec.id] ?? ""}
                       onChange={(e) => setVals((v) => ({ ...v, [spec.id]: e.target.value.trim() }))} />
              </div>
            ))}
          </div>
          <div className="triage-results">
            {filled.length === 0 && (
              <span className="triage-empty">
                Paste a userId, traceId, or contractId above to generate deeplinks.
              </span>
            )}
            {filled.flatMap(([key, val]) => (
              (templates[key] ?? []).map((t, i) => (
                <a key={`${key}-${i}`}
                   className={`triage-chip${t.confidence === "unverified" ? " unverified" : ""}`}
                   target="_blank" rel="noopener noreferrer"
                   href={t.url.replace(`{${key}}`, encodeURIComponent(val))}
                   title={t.notes ?? t.url}>
                  <ExternalLink size={13} />
                  <span>{t.tool}</span>
                </a>
              ))
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
